const THEME_KEY = 'brb_theme';
const THEMES = ['parchment', 'ledger', 'slate-light', 'ink', 'slate', 'wine'];
const DEFAULT_THEME = 'parchment';

const themeSelect = document.getElementById('themeSelect');

const applyTheme = (theme) => {
  if (theme === DEFAULT_THEME) {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', theme);
  }
  window.dispatchEvent(new CustomEvent('themechange'));
};

export const initTheme = () => {
  let stored = DEFAULT_THEME;
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved && THEMES.includes(saved)) stored = saved;
  } catch {}

  applyTheme(stored);
  if (themeSelect) themeSelect.value = stored;

  themeSelect?.addEventListener('change', (event) => {
    const theme = THEMES.includes(event.target.value) ? event.target.value : DEFAULT_THEME;
    applyTheme(theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  });
};
